export function calculateNutritionTargets(data) {
  const { gender, dob, currentWeight, height, activityLevel, goal } = data;

  if (!gender || !dob || !currentWeight || !height || !activityLevel || !goal) {
    return null;
  }

  // Age in completed years — subtract 1 if birthday hasn't occurred yet this calendar year
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const birthdayThisYear = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
  if (today < birthdayThisYear) age -= 1;

  const weightKg = parseFloat(currentWeight);
  const heightCm = parseFloat(height);

  if (!weightKg || !heightCm || !age) return null;

  // Mifflin-St Jeor BMR equation
  let bmr;
  if (gender === "male") {
    bmr = 10 * weightKg + 6.25 * heightCm - 5 * age + 5;
  } else {
    bmr = 10 * weightKg + 6.25 * heightCm - 5 * age - 161;
  }

  // TDEE = BMR × activity multiplier
  const activityMultipliers = {
    sedentary: 1.2,
    lightly: 1.375,
    moderately: 1.55,
    very: 1.725,
  };

  const tdee = bmr * (activityMultipliers[activityLevel] || 1.2);

  // Adjust TDEE for goal
  let targetCalories;
  if (goal === "lose") targetCalories = Math.round(tdee - 500);
  else if (goal === "gain") targetCalories = Math.round(tdee + 300);
  else targetCalories = Math.round(tdee);

  // Safety floor per standard nutrition guidelines — prevents dangerously low targets
  const calorieFloor = gender === "male" ? 1800 : 1500;
  if (targetCalories < calorieFloor) targetCalories = calorieFloor;

  // Macro split: 20% protein / 50% carbs / 30% fat
  const protein = Math.round((targetCalories * 0.20) / 4);
  const carbs   = Math.round((targetCalories * 0.50) / 4);
  const fats    = Math.round((targetCalories * 0.30) / 9);

  return { calories: targetCalories, protein, carbs, fats, bmr: Math.round(bmr), tdee: Math.round(tdee) };
}
